import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { ProtocolDetModel } from 'src/app/models/ProtocolDetModel';
import { ProtocolDetService } from 'src/app/services/ProtocolDetService';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { LocalStorageService } from 'ngx-webstorage';
import {formatDate} from '@angular/common';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ItemsService } from 'src/app/services/ItemsService';
import Swal from 'sweetalert2';
import { PharmGroupModel } from 'src/app/models/PharmGroupModel';
import { PharmGroupService } from 'src/app/services/PharmGroupService';
import { ItemsearchcatComponent } from '../itemsearchcat/itemsearchcat.component';

@Component({
  selector: 'app-protocol-edit',
  templateUrl: './protocol-edit.component.html',
  styleUrls: ['./protocol-edit.component.css']
})
export class ProtocolEditComponent implements OnInit {
prhdcode = '' ;
prdetcategory = '' ;
table_prdetcategory = '' ;
prdetitcode = '' ;
prdetitname = '' ;
prdetunit = '' ;
prdetdose = 0 ;
prdetqty = 0 ;
prdetrote = 0 ;
prdetduration = '' ;
prdetnotes = '' ;
prdetstep = '' ;
compcode = '' ;
userid = '' ;
wk_linestatus = 'New';
modifieddate = '' ;
status = '';
  itCode ='';
  itCode1 ='';
  itCode2 ='';

  itTName = '';
  itTName1 ='';
  itTName2 ='';

  pharmGroupList: PharmGroupModel[] =[];
  itemsList: ItemsModel[] =[];
  itemsList1: ItemsModel[] =[];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(private dialogref: MatDialog,
              public pharmgroupService:PharmGroupService ,
              public itemsService : ItemsService,
              public items : ItemsModel,
              public protocolDet : ProtocolDetModel,
              public protocolDetService :ProtocolDetService,
    public dialogRef: MatDialogRef<ProtocolEditComponent>,
    public storage: LocalStorageService,
    @Inject(MAT_DIALOG_DATA) public data :any,
   ) {
      this.prhdcode = data.prhdcode,
      this.prdetcategory = data.prdetcategory ;
      this.table_prdetcategory = data.prdetcategory ;
      this.prdetitcode = data.prdetitcode ;
      this.prdetitname = data.prdetitname ;

      this.prdetdose = data.prdetdose ;
      this.prdetqty = data.prdetqty ;
      this.prdetrote = data.prdetrote ;
      this.prdetduration = data.prdetduration ;
      this.prdetnotes = data.prdetnotes ;
      this.prdetstep = data.prdetstep ;
      this.prdetunit = data.prunit;
      this.wk_linestatus = data.linestatus;
      // if(this.prdetstep == '0'){ this.status = 'New'
      //                         this.prdetstep = '' };

     }

  ngOnInit(): void {
   this.retrivePharmGroupLookupTop();
   this.retriveItemsLookupCat();
  }
  retrivePharmGroupLookupTop() {
    this.pharmgroupService
      .getPharmGroupLookupTop(this.storage.retrieve('stgcompCode'))
      .subscribe((data: PharmGroupModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.pharmGroupList[i] = data[i];
        }
      });
  }
  retriveItemsLookupCat() {
    if (this.prdetcategory != '2'){
    this.itemsService.getItemsLookupCat(this.prdetcategory) .subscribe((data: ItemsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.itemsList[i] = data[i];
        }
      });
    }
    if (this.prdetcategory == '2'){
      this.itemsService.getItemsLookupTop(this.storage.retrieve('stgcompCode')) .subscribe((data: ItemsModel[]) => {
          for (let i = 0; i < data.length; i++) {
            this.itemsList[i] = data[i];
          }
        });
      }
  }
  submitProtocolDet_1() {
    this.protocolDet.prHdCode = this.prhdcode;
    this.protocolDet.prDetCategory = this.table_prdetcategory;

    this.protocolDet.prDetItCode = this.prdetitcode;
    this.protocolDet.prDetItName = this.itTName;
    this.protocolDet.prDetUnit = this.prdetunit;
    this.protocolDet.prDetDose = this.prdetdose;

    this.protocolDet.prDetQty = this.prdetqty;
    this.protocolDet.prDetRote = this.prdetrote;
    this.protocolDet.prDetDuration = this.prdetduration;
    this.protocolDet.prDetNotes = this.prdetnotes;
    this.protocolDet.prDetStep = this.prdetstep;

    this.protocolDet.userID = this.storage.retrieve('stguserId');
    this.protocolDet.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.protocolDet.compCode = this.storage.retrieve('stgcompCode');

    if (this.wk_linestatus != 'New'){
      this.protocolDetService.AddProtocolDetCat(this.protocolDet).subscribe(data => {
      },

        error => { alert(error); }
      );
    }
    if (this.wk_linestatus == 'New'){

      this.protocolDetService.AddProtocolDetCatNew(this.protocolDet).subscribe(data => {
      },
        error => { alert(error); }
      );
    }

    this.dialogref.closeAll();
  }
  mesgDelete(){
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
        this.deletePreNedication();
        Swal('Deleted!', 'Your record has been deleted.', 'success');

      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  deletePreNedication() {

    this.protocolDetService.delProtocolDetCat(this.prhdcode,this.prdetcategory,this.prdetitcode,this.prdetstep).subscribe(
    (data: ProtocolDetModel) => {
    }
  );
  this.dialogref.closeAll();
}
  CloseDialog(){
    this.dialogref.closeAll();
  }
  openDialogItems(){
    const dialogRef = this.dialogref.open(ItemsearchcatComponent,
      {
        data: {
          dataKey: this.items,
          detcategory : this.prdetcategory
        }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
       dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.prdetitcode = result.itCode;
        this.prdetitname = result.itTName;


        dialogSubmitSubscription.unsubscribe();
      });

  }
}
